import { useContext } from "react";
import { AutoScrollContext } from "@/providers/AutoScrollContext/AutoScrollProvider";

export const useAutoScrollState = () => useContext(AutoScrollContext);
